import styled from '@emotion/styled'

const AddContact = ({ className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      Add contact
    </div>
  )
}

export default styled(AddContact)`
  color: ${props => props.theme.color.monochrome.superDark};
  cursor: pointer;
`
